import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import moment from 'moment'

import InputStandard from 'components/input/standard'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import { 
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

import {
    dismissTask
} from 'state/actions'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

class ModalDismiss extends Component {
	state = {
        id: null,
        unitId: 2,
        unit: 1
	}
	
	componentDidMount = _ => { 
    	setTimeout(_ => { 
			if(this.announcementRef){
				this.announcementRef.inputRef.focus()
			}
		}, 1)
	}

	handleSubmit = _ => {
		const {
            handleError,
            dismissTask,
            userData,
            data,
            closeCallback
        } = this.props

        const unitNumber = parseInt(this.state.unit)

        if(isNaN(unitNumber) || !unitNumber){
            return handleError(`You'll need to enter a unit.`)
        }

        dismissTask(this.state, data.task, userData)

        closeCallback()
	}

	handleChange = (type, value) => {
        this.setState({
            [type]: value
        })
    }

	render() {		
		const {
            closeCallback,
            validateResponse,
            handleDismiss,
            data
        } = this.props

        const {
            unitId,
            unit
        } = this.state

		return(
			<div>
				<div className={'borders'}>
                    <h3>
                        { data && data.task ? '"'+data.task.name+'"' : "" }
                    </h3>
                    <p>
                        Hide this from my dashboard for:
                    </p>
                    <InputStandard
                        placeholder={`1`}
                        ref={ref => this.announcementRef = ref }
                        name="title"
                        onChange={e => this.handleChange('unit', e.target.value)}
                        value={unit}
                    />
                    <DropdownMenu 
                        isObjects={true} 
                        selectableItems={[
                            {
                                id: 1,
                                name: unit != 1 ? 'days' : 'day'
                            },{
                                id: 2,
                                name: unit != 1 ? 'weeks' : 'week'
                            },{
                                id: 3,
                                name: unit != 1 ? 'months' : 'month'
                            }
                        ]} 
                        selectedItemId={unitId} 
                        handleChange={e => this.handleChange('unitId', e)} 
                        parentType="unit" 
                    />
                    <div>
                        <ValidateResponse 
                            dismissCallback={handleDismiss} 
                            response={validateResponse} 
                        />
                    </div>
				</div>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.handleSubmit} 
					label={'Submit'} 
					icon={'check'}
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {  
  return {
    accountData: getCurrentAccount(state),
	userData: getCurrentUser(state),
  }
}

const ModalDismissWithValidateResponse = withValidateResponse(ModalDismiss)

export default connect(mapStateToProps, {
    dismissTask
})(ModalDismissWithValidateResponse)
